/* eslint-disable no-unused-expressions */
import jwt_decode from 'jwt-decode';
import { goBack } from 'connected-react-router';
import * as bankAccountService from '@services/bank-account-service';
import { errorResponsive, successResponsive } from '@constants/errorObjects';
import { showError } from '@store/logged/actions';
import { usersService } from '@services';
import * as usersActions from '@store/users/actions';
import _ from 'lodash';
import {
  defaultDocumentType,
  isCountryChileOrPeru,
  isCountryPeruOrColombia,
} from '@constants/regions';
import { bankAccountDTO } from '@helpers/bankAccount';
import * as loginService from '@services/login-service';
import * as popUpServices from '@services/pop-up-service';
import { merchantAdapter } from '@helpers/merchant';
import * as loginTypes from './actionTypes';
import * as loggedActions from '../logged/actions';
import * as commonActions from '../common/actions';

export const setEmailLogin = ({ ...data }) => ({
  type: loginTypes.SET_LOGIN_DATA,
  payload: merchantAdapter(data),
});
export const setToken = (token) => ({
  type: loginTypes.SET_TOKEN,
  payload: token,
});
export const setDocumentStatus = (documentStatus) => ({
  type: loginTypes.SET_DOCUMENT_STATUS,
  payload: documentStatus,
});
export const setLink = (link) => ({
  type: loginTypes.SET_LINK,
  payload: link,
});
export const setRecoverEmail = (email) => ({
  type: loginTypes.SET_RECOVER_EMAIL,
  payload: email,
});
export const setLoginData = (data) => ({
  // deprecated
  type: loginTypes.SET_USER_AUTH,
  payload: { ...data },
});
export const deleteLoginData = () => ({
  type: loginTypes.DELETE_USER_AUTH,
});
export const addBankAccount = (data) => ({
  type: loginTypes.ADD_BANK_ACCOUNT,
  payload: data,
});
export const setJWT = (jwt) => ({
  type: loginTypes.SET_JWT,
  payload: { ...jwt },
});
export const setMerchants = (data) => ({
  type: loginTypes.SET_MERCHANTS,
  payload: { ...data },
});
export const disableBankAccounts = () => ({
  type: loginTypes.DISABLE_BANK_ACCOUNTS,
});
export const deleteLoginValues = (isExpired = false) => ({
  type: loginTypes.DELETE_LOGIN_VALUES,
  payload: isExpired,
});
export const setLoguedAs = (data) => ({
  type: loginTypes.SET_LOGUED_AS,
  payload: { ...data },
});

export const setAccessControll = (accessControl) => ({
  type: loginTypes.SET_ACCESS_CONTROL,
  payload: accessControl,
});

export const setUpdateAutoCashout = () => ({
  type: loginTypes.UPDATE_AUTO_CASHOUT,
});

export const setTermsExpirationDate = (data) => ({
  type: loginTypes.SET_TERMS_EXPIRATION_DATE,
  payload: data,
});

export const setTermsVersion = (data) => ({
  type: loginTypes.SET_TERMS_VERSION,
  payload: data,
});

export const setIsTermsExpired = (data) => ({
  type: loginTypes.SET_IS_TERMS_EXPIRED,
  payload: data,
});

export const setTermsConditions = (data) => ({
  type: loginTypes.SET_TERMS_CONDITIONS,
  payload: data,
});
export const setUsersByRut = (data) => ({
  type: loginTypes.SET_USERS_BY_RUT,
  payload: data,
});

export const setErrorUsersByRut = (error) => ({
  type: loginTypes.SET_ERROR_USERS_BY_RUT,
  payload: error,
});

export const cleanUsersByRut = () => ({
  type: loginTypes.CLEAN_USERS_BY_RUT,
});
export const setAuth = (auth) => ({
  type: loginTypes.SET_AUTH,
  payload: auth,
});

export const loginSuccess =
  ({ jwt, loguedAs, access_control: accessControl }) =>
  (dispatch) => {
    dispatch(setJWT(jwt));
    dispatch(setAuth(jwt_decode(jwt.access_token)));
    dispatch(setLoguedAs(loguedAs));
    dispatch(commonActions.getDocumentsTypes());
    dispatch(commonActions.getContactEmail());
    isCountryChileOrPeru && dispatch(commonActions.getNpsWidget());
    isCountryPeruOrColombia && dispatch(commonActions.getBankCodes());
    dispatch(setAccessControll(accessControl));
  };
export const logout = (data) => (dispatch) => {
  loginService.logout(
    data,
    () => dispatch(deleteLoginValues()),
    (error) => {
      dispatch(deleteLoginValues());
      dispatch(loggedActions.showError(error));
    }
  );
};

export const createBankAccount = (bankAccount) => (dispatch) => {
  dispatch(commonActions.showLoading());
  const payload = {
    bank_account: bankAccountDTO(bankAccount),
  };
  return bankAccountService
    .createBankAccount(payload)
    .then((response) => {
      dispatch(addBankAccount(response.bank_account));
      dispatch(goBack());
      dispatch(showError(successResponsive('Tu cuenta bancaria se agrego con éxito')));
    })
    .catch((error) => dispatch(showError(errorResponsive(error))))
    .finally(() => dispatch(commonActions.hideLoading()));
};

export const updateBankAccount = (bankAccount) => (dispatch) => {
  dispatch(commonActions.showLoading());
  const payload = {
    bank_account: bankAccountDTO(bankAccount),
  };
  return bankAccountService
    .updateBankAccount({ bankAccountId: bankAccount._id, payload })
    .then((response) => {
      dispatch(disableBankAccounts());
      dispatch(addBankAccount(response.bank_account));
      dispatch(goBack());
      setTimeout(() => {
        dispatch(showError(successResponsive('Tu cuenta bancaria se actualizó con éxito')));
      }, 0);
    })
    .catch((error) => dispatch(showError(errorResponsive(error))))
    .finally(() => dispatch(commonActions.hideLoading()));
};

export const deleteBankAccount = (bankAccountId) => (dispatch) => {
  dispatch(commonActions.showLoading());
  return bankAccountService
    .deleteBankAccount(bankAccountId)
    .then(() => {
      dispatch(disableBankAccounts());
      setTimeout(() => {
        dispatch(showError(successResponsive('Tu cuenta bancaria se eliminó con éxito')));
      }, 0);
    })
    .catch((error) => dispatch(showError(errorResponsive(error))))
    .finally(() => dispatch(commonActions.hideLoading()));
};

export const updateRepresentant =
  (
    { legalAgentId, representant, isNewPhone, isNewEmail, password, updateUserSelected = false },
    callbackError
  ) =>
  (dispatch, getState) => {
    const {
      login: { merchant },
    } = getState();
    const payload = {
      id_user: legalAgentId,
      business_name: merchant.business_name,
      merchant_name: merchant.merchant_name,
      update_email: isNewEmail,
      email: representant.email,
      merchants: merchant.merchants,
      address_info: merchant.address_info,
      address: merchant.address,
      update_phone: isNewPhone,
      phones: representant.phones,
      password,
    };
    dispatch(commonActions.showLoading());
    return usersService
      .updateUserProfile(payload)
      .then((response) => {
        dispatch(commonActions.clearFormValidationErrors());
        dispatch(setEmailLogin(response));
        dispatch(usersActions.setLegalAgent(response.legal_agent));
        if (isNewEmail) {
          dispatch(
            commonActions.setFormValidationErrors({
              hasError: false,
              fields: [],
            })
          );
          const {
            login: { auth },
          } = getState();
          dispatch(logout(auth.payload));
        } else {
          if (updateUserSelected) {
            const { phones } = response.legal_agent;
            dispatch(usersActions.setPhoneUserSelected(phones));
          }
          dispatch(goBack());
          dispatch(showError(successResponsive('El representante legal se actualizó con éxito')));
        }
      })
      .catch((error) => {
        // FIXME: actualizar esta validacion cuando se migre el bff al nuevo formato de errores
        if (error.message === 'Error creating jwt: Invalid Access') {
          dispatch(
            commonActions.setFormValidationErrors({
              hasError: true,
              fields: ['entryPassword'],
            })
          );
        } else {
          callbackError(error);
        }
      })
      .finally(() => dispatch(commonActions.hideLoading()));
  };

export const updateMerchantProfile = (legalAgentId, merchantProfile) => (dispatch) => {
  dispatch(commonActions.showLoading());
  const payload = {
    id_user: legalAgentId,
    business_name: merchantProfile.business_name,
    merchant_name: merchantProfile.merchant_name,
    update_email: false,
    email: merchantProfile.legal_agent.email,
    merchants: merchantProfile.merchants,
    address_info: merchantProfile.address_info,
    address: merchantProfile.address,
    update_phone: false,
    phones: merchantProfile.legal_agent.phones,
    password: null,
  };
  return usersService
    .updateUserProfile(payload)
    .then((response) => {
      dispatch(setEmailLogin(response));
      dispatch(goBack());
      dispatch(showError(successResponsive('Tu comercio se actualizó con éxito')));
    })
    .catch((error) => {
      dispatch(showError(errorResponsive(error)));
    })
    .finally(() => dispatch(commonActions.hideLoading()));
};

export const updateAutoCashout = () => (dispatch) => {
  dispatch(commonActions.showSkeleton());
  bankAccountService
    .updateAutoCashout()
    .then(() => {
      dispatch(setUpdateAutoCashout());
    })
    .catch((error) => {
      dispatch(showError(errorResponsive(error)));
    })
    .finally(() => {
      dispatch(commonActions.hideSkeleton());
    });
};
const errorTest = {
  analyticsId: undefined,
  code: 400,
  showSnackBar: true,
  title: `No hay ninguna cuenta creada con ese ${defaultDocumentType.toLowerCase()}`,
};

export const getUsersByRut = (rut) => (dispatch) =>
  loginService
    .fetchUsersByRut(rut)
    .then((res) => {
      const data = _.zip(res?.merchants, res?.users);
      _.isEmpty(data)
        ? [dispatch(commonActions.showError(errorTest)), dispatch(setErrorUsersByRut(errorTest))]
        : dispatch(setUsersByRut(data));
    })
    .catch((error) => {
      dispatch(setErrorUsersByRut(error));
      dispatch(showError(error));
    });

export const successDisablePopUp = () => ({
  type: loginTypes.SUCCESS_DISABLE_VIEW_POP_UP,
});

export const disableViewPopUp = () => (dispatch) =>
  popUpServices
    .disablePopUp()
    .then(() => dispatch(successDisablePopUp()))
    .catch((error) => {
      dispatch(showError(error));
    });
